import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx'
import './index.css'
import { initializeAnalytics } from '@/services/analytics';
import { reportWebVitals } from '@/utils/webVitals';

initializeAnalytics();
reportWebVitals();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
